var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text-center"},[_vm._v("There are no "+_vm._s(_vm._f("capitalize")(_vm.name))+" available!!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }